import createDuck from '../../../lib/ducks/remoteDuck'
import Return from '../../../lib/api/return'

export default createDuck({
  namespace: 'content',
  store: 'returnItem',
  fetchCallback: Return.handleFetch,
})
